import script from "./zcxq.vue?vue&type=script&setup=true&lang=js"
export * from "./zcxq.vue?vue&type=script&setup=true&lang=js"

import "./zcxq.vue?vue&type=style&index=0&id=90a2422e&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a2422e"]])

export default __exports__